export enum SelfieIDOption {
  DriversLicence = 'DriversLicence',
  Passport = 'Passport',
}
